/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProvisioningType {

    PRODUCT_STANDARD = 'PRODUCT_STANDARD',

    CONFIGURATION = 'CONFIGURATION',

    ADD_ON_MODULE = 'ADD_ON_MODULE',

    PARTNER_SOLUTION = 'PARTNER_SOLUTION',

    CUSTOMIZING = 'CUSTOMIZING',

    THIRD_PARTY_SYSTEM = 'THIRD_PARTY_SYSTEM',

    ROADMAP = 'ROADMAP',

    NOT_AVAILABLE = 'NOT_AVAILABLE'
}

